import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicTextArea, BasicInput, NumericInputField, BasicFieldCheckbox, BaasicFieldDropdown } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function ProductEditTemplate({ editView }) {
    const {
        contentLoading,
        form,
        categoryStore,
        isEdit,
        unitOfMeasureStore,
        subCategoryStore,
        isEnteralItemSelected,
        itemTypeStore,
        innerCannulaStore,
        productTypeStore,
        pumpBrandStore,
        showInnerCannulaDropdown,
        showPumpBrand,
        showProductType,
        procedureCodeStore,
        specialtyTypeStore,
        showSpecialtyType,
        parentProductStore,
        widthMeasurementUnitStore,
        heightMeasurementUnitStore,
        isWoundCareItemSelected,
        woundCareItemSubcategoryStore,
        tagsStore,
        showProductTags,
        vendorStore,
        showVendor,
        isDiscontinued
    } = editView;

    const productDropdownItemRender = (li, itemProps) => {
        const itemName = itemProps && itemProps.dataItem.description;

        const itemChildren = (
        <span
            style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            }}
        >
            <span style={{
                flex: "1"
            }}>
                {li.props.children}
            </span>
            <span style={{
                fontSize: "12px"
            }}>
                {itemName}
            </span>
        </span>
        );

        return React.cloneElement(li, li.props, itemChildren);
    }

    return (
        <ApplicationEditLayout store={editView}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-8 col-lrg-7">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                    <BasicInput field={form.$('itemId')} />
                                </div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('description')} />
                                </div>
                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                    <BasicInput field={form.$('alternativeName')} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('itemCategoryId')} store={categoryStore} />
                                </div>
                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('subCategoryId')} store={subCategoryStore}/>
                                </div>
                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('procedureCodeId')} store={procedureCodeStore}/>
                                    {/* <BasicInput field={form.$('procedureCode')} /> */}
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-2 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('unitOfMeasureId')} store={unitOfMeasureStore} />
                                </div>
                                <div className="form__group col col-lrg-2 u-mar--bottom--sml">
                                    <NumericInputField field={form.$('units')} />
                                </div>
                                <div className="form__group col col-lrg-2 u-mar--bottom--sml">
                                    <NumericInputField field={form.$('qtyPerCase')} />
                                </div>                               
                                <div className="form__group col col-lrg-2 u-mar--bottom--sml">
                                    <NumericInputField field={form.$('defaultQuantity')} />
                                </div>                               
                                <div className="form__group col col-lrg-2 u-mar--bottom--sml">
                                    <BasicInput field={form.$('mcrallowable')} />
                                </div>
                                <div className="form__group col col-lrg-2 u-mar--bottom--sml">
                                    <NumericInputField field={form.$('amountOfUnitsToSend')} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-2 u-mar--bottom--sml">
                                    <NumericInputField field={form.$('calsPerMl')} disabled={!isEnteralItemSelected} />
                                </div>
                                <div className="form__group col col-lrg-2 u-mar--bottom--sml">
                                    <NumericInputField field={form.$('caloriesPerContainer')} disabled={!isEnteralItemSelected} />
                                </div>    
                                <div className="form__group col col-lrg-2 u-mar--bottom--sml">
                                    <NumericInputField field={form.$('mlsPerContainer')} disabled={!isEnteralItemSelected}/>
                                </div>                           
                                <div className="form__group col col-lrg-2 u-mar--bottom--sml">
                                    <BasicInput field={form.$('containerSize')} disabled={!isEnteralItemSelected}/>
                                </div>
                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('itemTypeId')} store={itemTypeStore} disabled={!isEnteralItemSelected}/>
                                </div>
                            </div>
                            <div className="row">
                                {showInnerCannulaDropdown && <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('innerCannulaId')} store={innerCannulaStore} itemRender={productDropdownItemRender}/>
                                </div>}
                                {showProductType && <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('defaultItemTypeId')} store={productTypeStore} allowEmpty={true}/>
                                </div>}
                                {showPumpBrand && <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('pumpBrandId')} store={pumpBrandStore} allowEmpty={true}/>
                                </div>}
                                {showSpecialtyType && <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('specialtyTypeId')} store={specialtyTypeStore} allowEmpty={true}/>
                                </div>}
                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('parentProductId')} store={parentProductStore} itemRender={productDropdownItemRender}/>
                                </div>
                                {showProductTags && 
                                    <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                        <BaasicFieldDropdown field={form.$('productTagIds')} store={tagsStore} allowEmpty={true}/>
                                    </div>
                                }
                                {showVendor &&
                                    <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                        <BaasicFieldDropdown field={form.$('vendorId')}  required={true} store={vendorStore} />
                                    </div>
                                }
                                 <div className={`form__group col col-lrg-2 u-mar--bottom--sml u-flex--self--center`}>
                                    <BasicFieldCheckbox className="has-fake-label"  field={form.$('isSAPs')}/><span className="fake-label">SAPs</span>
                                </div>
                                <div className={`form__group col col-lrg-3 u-mar--bottom--sml col--flex u-flex--self--center`}>
                                    <div className="fake-title"></div>
                                     <button
                                        type="button"
                                        className={`toggle-switch ${form.$("billableToMedicare").value ? "on" : "off"}`}
                                        onClick={() => form.$('billableToMedicare').set(!form.$('billableToMedicare').value)}
                                    >
                                        <span className="toggle-switch__circle"></span>
                                    </button>
                                    <span className="fake-label">Billable To Medicare</span>
                                </div>
                                <div className={`form__group col col-lrg-2 u-mar--bottom--sml u-flex--self--center`}>
                                    <BasicFieldCheckbox className="has-fake-label"  field={form.$('isPreferred')}/><span className="fake-label">Is Preferred</span>
                                </div>
                                {isEdit && <div className="form__group col col-lrg-2 u-mar--bottom--sml u-flex--self--center">
                                    <BasicFieldCheckbox field={form.$('isActive')}/>Discontinued
                                </div>}    
                                <div className="form__group col col-lrg-2 u-mar--bottom--sml u-flex--self--center">
                                    <BasicFieldCheckbox field={form.$('backordered')} disabled={isDiscontinued} />
                                    <span className="checkbox__text">Backordered</span>
                                </div>                                     
                            </div>

                            {isWoundCareItemSelected && <div className="row">
                                <div className="form__group form__combined--left col col-lrg-2 u-mar--bottom--sml">
                                    <NumericInputField field={form.$('height')} />
                                </div>
                                <div className="form__group form__combined--right col col-lrg-4 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('heightMeasurementUnitId')} store={heightMeasurementUnitStore}/>
                                </div>
                                <div className="form__group form__combined--left col col-lrg-2 u-mar--bottom--sml">
                                    <NumericInputField field={form.$('width')} />
                                </div>
                                <div className="form__group form__combined--right col col-lrg-4 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('widthMeasurementUnitId')} store={widthMeasurementUnitStore}/>
                                </div>
                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('woundCareItemSubCategoryId')} store={woundCareItemSubcategoryStore} />
                                </div>     
                            </div>}

                            <div className="row">
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicTextArea field={form.$('notes')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

ProductEditTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ProductEditTemplate);
